import {
  CommentsResponse,
  WarrantyReleaseRequest,
  WarrantyReleaseRequestDetail
} from '@/modules/support/types/WarrantyReleaseRequest.ts'
import { ListResponse } from '@/core/types/ListResponse.ts'
import {
  ClientEditRequest,
  ClientEditRequestDetail
} from '@/modules/support/types/ClientEditRequest.ts'
import {
  ArticleEditRequest,
  ArticleEditRequestDetail
} from '@/modules/support/types/ArticleEditRequest.ts'
import {
  ArticleChangeRequest,
  ArticleChangeRequestDetail
} from '@/modules/support/types/ArticleChangeRequest.ts'
import {
  ArticleDeleteRequest,
  ArticleDeleteRequestDetail
} from '@/modules/support/types/ArticleDeleteRequest.ts'
import {
  ArticleReassignRequest,
  ArticleReassignRequestDetail
} from '@/modules/support/types/ArticleReassignRequest.ts'
import img from '@/assets/images/avatar-1.jpg'

export const releaseRequestPage1: {
  data: ListResponse<WarrantyReleaseRequest>
} = {
  data: {
    results: [
      {
        id: '1',
        description: 'Solicitud de liberación de fondos para proyecto A',
        title: 'Liberación de Fondos - Proyecto A',
        registerNumber: 'REQ-2024-001',
        createdBy: 'Juan Pérez',
        updatedBy: 'María García',
        createdAt: '15/01/2024',
        updatedAt: '20/01/2024',
        amountComments: '5',
        branchOfficeName: 'Sucursal Centro',
        commercialAllyName: 'Banco Nacional',
        status: 'CREADA'
      },
      {
        id: '4',
        description: 'Solicitud de liberación por reinstalar',
        title: 'Liberación de Fondos - Proyecto A',
        registerNumber: 'REQ-2024-001',
        createdBy: 'Juan Pérez',
        updatedBy: 'María García',
        createdAt: '15/01/2024',
        updatedAt: '20/01/2024',
        amountComments: '5',
        branchOfficeName: 'Sucursal Centro',
        commercialAllyName: 'Banco Nacional',
        status: 'REINSTALAR'
      },
      {
        id: '2',
        description: 'Aprobación de crédito para cliente empresarial',
        title: 'Crédito Empresarial - Cliente XYZ',
        registerNumber: 'REQ-2024-002',
        createdBy: 'Ana López',
        updatedBy: 'Carlos Rodríguez',
        createdAt: '16/01/2024',
        updatedAt: '21/01/2024',
        amountComments: '3',
        branchOfficeName: 'Sucursal Norte',
        commercialAllyName: 'Banco Comercial',
        status: 'COMPLETADA'
      },
      {
        id: '3',
        description: 'Solicitud de refinanciamiento de deuda',
        title: 'Refinanciamiento - Cliente ABC',
        registerNumber: 'REQ-2024-003',
        createdBy: 'Roberto Silva',
        updatedBy: 'Laura Martínez',
        createdAt: '17/01/2024',
        updatedAt: '22/01/2024',
        amountComments: '7',
        branchOfficeName: 'Sucursal Sur',
        commercialAllyName: 'Banco Regional',
        status: 'RECHAZADA'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const clientEditRequestPage1: { data: ListResponse<ClientEditRequest> } =
  {
    data: {
      results: [
        {
          id: '1',
          status: 'APROBADA',
          reason: 'Mi razon 1',
          createdBy: 'Ana Sofía',
          updatedBy: 'Luis Miguel',
          createdAt: '04/02/2024',
          updatedAt: '04/02/2024',
          name: 'Juana',
          lastName: 'de la caridad',
          phone: '123123',
          email: 'juana@gmail.com',
          documentNumber: '12345678',
          birthDate: '05/02/2024',
          creditLimit: '300'
        },
        {
          id: '2',
          status: 'NUEVA',
          reason: 'Mi razon 2',
          createdBy: 'Petra Maria',
          updatedBy: 'Luis Miguel',
          createdAt: '04/02/2024',
          updatedAt: '04/02/2024',
          name: 'Anita',
          lastName: 'de la caridad',
          phone: '123123',
          email: 'anita@gmail.com',
          documentNumber: '87654321',
          birthDate: '05/02/2024',
          creditLimit: '300'
        },
        {
          id: '3',
          status: 'RECHAZADA',
          reason: 'Mi razon 3',
          createdBy: 'Esta nina',
          updatedBy: 'Luis Miguel',
          createdAt: '04/02/2024',
          updatedAt: '04/02/2024',
          name: 'Carla',
          lastName: 'de la caridad',
          phone: '123123',
          email: 'carla@gmail.com',
          documentNumber: '8765876',
          birthDate: '05/02/2024',
          creditLimit: '300'
        }
      ],
      total: [],
      status: true,
      pagination: {
        next: false,
        prev: false,
        start: 1,
        end: 3,
        range: [1],
        count: 3,
        pages: 1,
        total: 3,
        limit: 20
      }
    }
  }

export const articleEditRequestPage1: {
  data: ListResponse<ArticleEditRequest>
} = {
  data: {
    results: [
      {
        id: '1',
        status: 'NUEVA',
        createdBy: 'Anacleta',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: 12345678,
        imei: '1234567',
        cost: '200',
        additionalCost: '100',
        initial: '100',
        initialTotal: '300',
        totalPayment: '500',
        extraPayment: '50',
        paymentByQuotes: '250',
        quotes: [],
        reason: 'Porque me gusta'
      },
      {
        id: '2',
        status: 'APROBADA',
        createdBy: 'Hinajata',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: 12344321,
        imei: '7654567',
        cost: '200',
        additionalCost: '100',
        initial: '100',
        initialTotal: '300',
        totalPayment: '500',
        extraPayment: '50',
        paymentByQuotes: '250',
        quotes: [],
        reason: 'Porque no me gusta'
      },
      {
        id: '3',
        status: 'RECHAZADA',
        createdBy: 'Zazuke',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: 87654321,
        imei: '765988',
        cost: '200',
        additionalCost: '100',
        initial: '100',
        initialTotal: '300',
        totalPayment: '500',
        extraPayment: '50',
        paymentByQuotes: '250',
        quotes: [],
        reason: 'Porque mas o menos'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const articleChangeRequestPage1: {
  data: ListResponse<ArticleChangeRequest>
} = {
  data: {
    results: [
      {
        id: '1',
        status: 'APROBADA',
        createdBy: 'Koyiro',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        cost: '200',
        totalPayment: '300',
        newRegisterNumber: 12345678,
        oldRegisterNumber: 87654321,
        paymentType: '1',
        rate: '12',
        paymentByQuote: '500'
      },
      {
        id: '2',
        status: 'NUEVA',
        createdBy: 'Uzumaki',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        cost: '200',
        totalPayment: '300',
        newRegisterNumber: 3333333,
        oldRegisterNumber: 2222222,
        paymentType: '1',
        rate: '12',
        paymentByQuote: '500'
      },
      {
        id: '3',
        status: 'RECHAZADA',
        createdBy: 'Naruto',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        cost: '200',
        totalPayment: '300',
        newRegisterNumber: 11111111,
        oldRegisterNumber: 99999999,
        paymentType: '1',
        rate: '12',
        paymentByQuote: '500'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const articleReassignRequestPage1: {
  data: ListResponse<ArticleReassignRequest>
} = {
  data: {
    results: [
      {
        id: '1',
        status: 'APROBADA',
        createdBy: 'Anacleta',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '34534535',
        reason: 'porque si',
        originIdentification: '098765',
        destinationIdentification: '102938'
      },
      {
        id: '2',
        status: 'NUEVA',
        createdBy: 'Juaneta',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '73467y5',
        reason: 'porque no',
        originIdentification: '1039384',
        destinationIdentification: '7234586'
      },
      {
        id: '3',
        status: 'RECHAZADA',
        createdBy: 'Kilomayo',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '678475348',
        reason: 'por si  las moscas',
        originIdentification: '83554765',
        destinationIdentification: '36576'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const articleDeleteRequestPage1: {
  data: ListResponse<ArticleDeleteRequest>
} = {
  data: {
    results: [
      {
        id: '1',
        status: 'APROBADA',
        createdBy: 'Liudmila',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '12345678',
        clientName: 'Ana Cecilia',
        imei: '909090909',
        cost: '200',
        additionalCost: '54',
        initial: '100',
        initialTotal: '200',
        totalPayment: '300',
        extraPayment: '55',
        paymentByQuotes: '330',
        name: 'ni idea',
        reason: 'Porque me gusta',
        updatedBy: 'Antthony',
        brand: 'Apple',
        model: 'model2'
      },
      {
        id: '2',
        status: 'NUEVA',
        createdBy: 'Brenda',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '87654321',
        clientName: 'Carlota',
        imei: '888866666444',
        cost: '200',
        additionalCost: '54',
        initial: '100',
        initialTotal: '200',
        totalPayment: '300',
        extraPayment: '55',
        paymentByQuotes: '330',
        name: 'ni idea',
        reason: 'Porque no me gusta',
        updatedBy: 'Antthony',
        brand: 'Apple',
        model: 'model2'
      },
      {
        id: '3',
        status: 'RECHAZADA',
        createdBy: 'Pancrasio',
        createdAt: '04/02/2024',
        updatedAt: '04/02/2024',
        registerNumber: '645367434',
        clientName: 'Yisel',
        imei: '3339820983',
        cost: '200',
        additionalCost: '54',
        initial: '100',
        initialTotal: '200',
        totalPayment: '300',
        extraPayment: '55',
        paymentByQuotes: '330',
        name: 'ni idea',
        reason: 'Porque mas o menos',
        updatedBy: 'Antthony',
        brand: 'Apple',
        model: 'model2'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const warrantyRequestDetail: { data: WarrantyReleaseRequestDetail } = {
  data: {
    id: '1',
    description: 'Solicitud de liberación de fondos para proyecto A',
    title: 'Liberación de Fondos - Proyecto A',
    registerNumber: 'REQ-2024-001',
    createdBy: 'Juan Pérez',
    updatedBy: 'María García',
    createdAt: '15/01/2024',
    updatedAt: '20/01/2024',
    amountComments: '5',
    branchOfficeName: 'Sucursal Centro',
    commercialAllyName: 'Banco Nacional',
    status: 'CREADA',
    comments: [
      {
        id: 'c1',
        createdBy: 'Carlos López',
        createdAt: '16/01/2024T10:30:00',
        comment:
          'He revisado los mockups iniciales y me parecen muy buenos. Sugiero agregar más detalles en la sección de navegación.'
      },
      {
        id: 'c2',
        createdBy: 'Ana Martínez',
        createdAt: '16/01/2024T14:15:00',
        comment:
          'Estoy de acuerdo con Carlos. También creo que deberíamos considerar la versión móvil desde el inicio.'
      }
    ]
  }
}

export const clientEditRequestDetail: { data: ClientEditRequestDetail } = {
  data: {
    id: '1',
    clientId: '2',
    status: 'NUEVA',
    reason: 'Mi razon 1',
    createdBy: 'Ana Sofía',
    updatedBy: 'Luis Miguel',
    updatedAt: '04/02/2024',
    createdAt: '04/02/2024',
    name: 'Juana',
    lastName: 'de la caridad',
    phone: '123123',
    email: 'juana@gmail.com',
    documentNumber: '12345678',
    birthDate: '05/02/2024',
    creditLimit: '300',
    documentImage: img
  }
}

export const articleDeleteRequestDetail: { data: ArticleDeleteRequestDetail } =
  {
    data: {
      id: '8',
      name: 'Juana',
      clientName: 'GRISEL ESTRADA ENAMORADO',
      imei: '355767752027958',
      registerNumber: '8131943',
      cost: '200.00',
      additionalCost: '0.00',
      initial: '80.00',
      reason: null,
      status: 'NUEVA',
      deletionRequest: 'Se rompio la camara',
      initialTotal: '80.00',
      totalPayment: '700.00',
      extraPayment: null,
      paymentByQuotes: '600.00',
      modelId: '102',
      modelName: 'Honor',
      brandId: '1',
      brandName: 'SOPORTE 2',
      createdAt: '12/09/2025',
      updatedAt: null,
      createdBy: 'Grisel Test',
      updatedBy: null
    }
  }

export const creditDeletionHasLateQuotes: {
  data: { hasLateQuotes: boolean }
  message: string
} = {
  message: 'OK',
  data: { hasLateQuotes: true }
}

export const articleReassignRequestDetail: {
  data: ArticleReassignRequestDetail
} = {
  data: {
    id: '2',
    status: 'NUEVA',
    createdBy: 'Anacleta',
    createdAt: '04/02/2024',
    updatedAt: '04/02/2024',
    registerNumber: '34534535',
    reason: 'porque si',
    originIdentification: '098765',
    destinationIdentification: '102938',
    updatedBy: 'Pepe',
    imei: '5645645',
    brandId: '3',
    brandName: 'LG',
    modelName: 'Apple',
    modelId: '5',
    originClientId: '2',
    destinationClientId: '2'
  }
}

export const articleChangeRequestDetail: {
  data: ArticleChangeRequestDetail
} = {
  data: {
    id: '2',
    status: 'NUEVA',
    createdBy: 'Anacleta',
    createdAt: '04/02/2024',
    updatedAt: '04/02/2024',
    updatedBy: 'Pepe',
    cost: '200',
    totalPayment: '',
    quotes: [
      { quote: '20', dueAt: '12/05/2024' },
      { quote: '20', dueAt: '16/05/2024' },
      { quote: '20', dueAt: '25/05/2024' }
    ],
    creditId: '2',
    newRegisterNumber: 3434,
    oldRegisterNumber: 453534,
    paymentType: 'cuotes',
    rate: '3.75',
    paymentByQuote: '50',
    newModelId: '2',
    newModelName: 'REDMI 9',
    newBrandId: '3',
    newBrandName: 'XIAOMI',
    imei: '234534535'
  }
}

export const articleEditRequestDetail: {
  data: ArticleEditRequestDetail
} = {
  data: {
    id: '1',
    status: 'NUEVA',
    imei: '356938035643809',
    registerNumber: 20250001,
    cost: '350.75',
    additionalCost: '25.00',
    initial: '100.00',
    initialTotal: '125.00',
    totalPayment: '475.75',
    extraPayment: '50.00',
    paymentByQuotes: '39.65',
    createdBy: 'Juan',
    createdAt: '23/05/2025',
    updatedAt: '23/05/2025',
    reason: 'me gusto mucho',
    brandName: 'Lenovo',
    modelName: 'LG',
    rentabilityId: '2',
    updatedBy: 'Ana Maria',
    creditId: '1',
    quotes: [
      {
        quoteId: '5',
        creditId: '1',
        paymentDate: '23/05/2025',
        dueAt: '21/08/2025',
        quote: '50.00',
        status: 'PAGADA',
        paid: '20'
      },
      {
        quoteId: '6',
        creditId: '1',
        paymentDate: '23/05/2025',
        dueAt: '04/09/2025',
        quote: '50.00',
        status: 'PENDIENTE',
        paid: '20'
      }
    ],
    clientId: '2'
  }
}

export const requestComments: { data: CommentsResponse } = {
  data: {
    data: [
      {
        id: 'c1',
        createdBy: 'Carlos López',
        createdAt: '04/02/2024',
        comment:
          'He revisado los mockups iniciales y me parecen muy buenos. Sugiero agregar más detalles en la sección de navegación.'
      },
      {
        id: 'c2',
        createdBy: 'Ana Martínez',
        createdAt: '25/03/2024',
        comment:
          'Estoy de acuerdo con Carlos. También creo que deberíamos considerar la versión móvil desde el inicio.'
      }
    ]
  }
}
